<formio [form]='uploadForm' (change)="onFormChange($event)" [submission]="formData" [refresh]="refreshForm"></formio>

<button mat-stroked-button (click)="onSaveForm()">Save</button>
<button mat-stroked-button (click)="clearUploadList()">Clear</button>
